
import { useState, useEffect } from 'react';

export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const openScheduler = () => {
    const widgetButton = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widgetButton) {
      widgetButton.click();
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="cursor-pointer" onClick={() => scrollToSection('home')}>
            <div className={`text-2xl font-bold leading-tight ${isScrolled ? 'text-[#2C2C2C]' : 'text-white'}`}>
              RW Construction
            </div>
            <div className={`text-sm leading-tight ${isScrolled ? 'text-gray-600' : 'text-white/90'}`}>
              Las Vegas LLC
            </div>
          </div>

          <div className="hidden lg:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'}`}>
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'}`}>
              Services
            </button>
            <button onClick={() => scrollToSection('residential')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'}`}>
              Residential
            </button>
            <button onClick={() => scrollToSection('commercial')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'}`}>
              Commercial
            </button>
            <button onClick={() => scrollToSection('about')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'}`}>
              About Us
            </button>
            <button onClick={() => scrollToSection('financing')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'}`}>
              Financing
            </button>
            <button onClick={() => scrollToSection('contact')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'}`}>
              Contact
            </button>
            <button onClick={openScheduler} className="border-2 border-[#FF6B35] text-[#FF6B35] px-5 py-2 rounded-full text-sm font-semibold hover:bg-[#FF6B35] hover:text-white transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2">
              <i className="ri-calendar-schedule-line"></i>
              Schedule Appointment
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-[#FF6B35] text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#E55A2B] transition-colors whitespace-nowrap cursor-pointer">
              Get Free Estimate
            </button>
          </div>

          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden text-2xl cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 bg-white rounded-lg shadow-lg">
            <div className="flex flex-col gap-3 px-4 py-3">
              <button onClick={() => scrollToSection('home')} className="text-sm font-medium text-gray-700 hover:text-[#FF6B35] text-left cursor-pointer">Home</button>
              <button onClick={() => scrollToSection('services')} className="text-sm font-medium text-gray-700 hover:text-[#FF6B35] text-left cursor-pointer">Services</button>
              <button onClick={() => scrollToSection('residential')} className="text-sm font-medium text-gray-700 hover:text-[#FF6B35] text-left cursor-pointer">Residential</button>
              <button onClick={() => scrollToSection('commercial')} className="text-sm font-medium text-gray-700 hover:text-[#FF6B35] text-left cursor-pointer">Commercial</button>
              <button onClick={() => scrollToSection('about')} className="text-sm font-medium text-gray-700 hover:text-[#FF6B35] text-left cursor-pointer">About Us</button>
              <button onClick={() => scrollToSection('financing')} className="text-sm font-medium text-gray-700 hover:text-[#FF6B35] text-left cursor-pointer">Financing</button>
              <button onClick={() => scrollToSection('contact')} className="text-sm font-medium text-gray-700 hover:text-[#FF6B35] text-left cursor-pointer">Contact</button>
              <button onClick={openScheduler} className="border-2 border-[#FF6B35] text-[#FF6B35] px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#FF6B35] hover:text-white transition-colors whitespace-nowrap cursor-pointer mt-2 flex items-center justify-center gap-2">
                <i className="ri-calendar-schedule-line"></i>
                Schedule Appointment
              </button>
              <button onClick={() => scrollToSection('contact')} className="bg-[#FF6B35] text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#E55A2B] transition-colors whitespace-nowrap cursor-pointer">Get Free Estimate</button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
